/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery from '../graphql/queries/GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery.js';

const useGetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionCustomerGranteesCitiesAndPostalCodes: R.omit(['__typename'], data?.getSouscriptionCustomerGranteesCitiesAndPostalCodes_souscription_customer_grantees || {})
  };
};

export default useGetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery;
